import _sfc_main from './CloseButton.vue2.js';
import normalizeComponent from '../../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("button", { staticClass: "fds-portfolio__close-btn", attrs: { "type": "button", "aria-label": "close" }, on: { "click": function($event) {
    return _setup.onClose();
  } } }, [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--close" })]);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/portfolio/components/CloseButton.vue";
var CloseButton = __component__.exports;

export { CloseButton as default };
